import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["state", "city", "assoc"]
  static values = {
    citiesUrl: String,
    assocsUrl: String
  }

  connect() {
    this.stateSelect = new TomSelect(this.stateTarget, {
      maxOptions: null,
      allowEmptyOption: true,
      placeholder: "Choose a state"
    })
    this.citySelect = new TomSelect(this.cityTarget, {
      maxOptions: null,
      allowEmptyOption: true,
      placeholder: "Choose a city"
    })
    this.assocSelect = new TomSelect(this.assocTarget, {
      maxOptions: null,
      allowEmptyOption: true,
      placeholder: "Choose an association"
    })

    this.applyEnabledState()

    this.stateTarget.addEventListener("change", () => this.onStateChange())
    this.cityTarget.addEventListener("change", () => this.onCityChange())
  }

  applyEnabledState() {
    if (this.stateSelect.getValue()) {
      this.citySelect.enable()
    } else {
      this.citySelect.disable()
    }
    if (this.stateSelect.getValue() && this.citySelect.getValue()) {
      this.assocSelect.enable()
    } else {
      this.assocSelect.disable()
    }
  }

  onStateChange() {
    this.resetSelect(this.citySelect)
    this.resetSelect(this.assocSelect)
    this.assocSelect.disable()

    const state = this.stateSelect.getValue()
    if (!state) {
      this.citySelect.disable()
      return
    }

    fetch(`${this.citiesUrlValue}?state=${encodeURIComponent(state)}`, {
      headers: { Accept: "application/json" }
    })
      .then(r => r.json())
      .then(options => {
        options.forEach(opt => this.citySelect.addOption({ value: opt.value, text: opt.text }))
        this.citySelect.refreshOptions(false)
        this.citySelect.enable()
      })
  }

  onCityChange() {
    this.resetSelect(this.assocSelect)

    const state = this.stateSelect.getValue()
    const city = this.citySelect.getValue()
    if (!state || !city) {
      this.assocSelect.disable()
      return
    }

    const params = new URLSearchParams({ state, city })
    fetch(`${this.assocsUrlValue}?${params}`, {
      headers: { Accept: "application/json" }
    })
      .then(r => r.json())
      .then(assocs => {
        assocs.forEach(a => this.assocSelect.addOption({ value: a.id, text: a.name }))
        this.assocSelect.refreshOptions(false)
        this.assocSelect.enable()
      })
  }

  resetSelect(select) {
    select.clear(true)
    select.clearOptions()
  }
}
